<script lang="ts">
	import type { PostFiltersSchema } from '$src/utils/api/feed.util';
	import InputMain from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';

  export let detail: PostFiltersSchema['files'] = { nFiles: 1 };
  export let isValid: boolean;
  let errorMessage: string;

  let _nFiles: string;

  if (detail.nFiles) {
    _nFiles = detail.nFiles.toString();
  }

  $: detail.nFiles = +_nFiles;
  $: isValid = typeof detail.nFiles === 'number' && detail.nFiles > 0 && _nFiles && true;
  $: errorMessage = isValid
    ? ''
    : isNaN(detail.nFiles)
      ? 'Input must not be alphabets or special characters'
      : 'Must be greater than zero';
</script>

<InputMain
  label="Files attached"
  bind:value={_nFiles}
  caption="Files attached to a single upload"
  danger={!isValid}
  bind:dangerMessage={errorMessage}
/>
